/* EWC · PDP · barra fixa: aparece depois da caixa de compra, leva de volta a ela e
   escreve a data de entrega prevista. */
(function () {
  function dataEntrega(dias) {
    var d = new Date();
    d.setDate(d.getDate() + dias);
    return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
  }
  function ligar() {
    var barra = document.getElementById('stickyAddToCart');
    if (!barra) return;
    var dias = parseInt(barra.getAttribute('data-prazo'), 10) || 5;
    barra.querySelectorAll('[data-ewc-data-entrega]').forEach(function (el) { el.textContent = dataEntrega(dias); });

    var alvo = document.querySelector('.shop-add-to-cart-wrapper');
    barra.querySelectorAll('.sticky-add-to-cart__button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (alvo) window.scrollTo({ top: Math.max(0, alvo.getBoundingClientRect().top + window.scrollY - 120), behavior: 'smooth' });
      });
    });
    function conferir() {
      if (!alvo) return;
      var r = alvo.getBoundingClientRect();
      barra.classList.toggle('ewc-visivel', r.bottom < 0);
    }
    conferir();
    window.addEventListener('scroll', conferir, { passive: true });
    window.addEventListener('resize', conferir);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligar);
  else ligar();
})();
